import { Color, ColorV2 } from "config/colors";
import { FontFamily, FontSize, TypographyV2 } from "config/font";
import styled from "styled-components";

type KeyProps = {
  backgroundColor?: ColorV2 | null;
};

export const Key = styled.div<KeyProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: clamp(92px, 11vh, 118px);
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : ColorV2.Blue1};
  border-radius: 24px;
  cursor: pointer;
  font-size: clamp(28px, 3vw, 40px);
  user-select: none;

  @media (max-width: 768px) {
    height: 90px;
    border-radius: 16px;
    font-size: 30px;
  }

  @media (max-width: 480px) {
    height: 80px;
    border-radius: 14px;
    font-size: 26px;
  }

  @media (max-width: 1180px) and (orientation: portrait) {
    height: 100%;
    min-height: 68px;
  }
`;

export const NumberPadContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 8px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }

  @media (max-width: 1180px) and (orientation: portrait) {
    flex: 1;
    min-height: 0;
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
`;

type FontProps = {
  color?: Color | ColorV2;
  fontSize?: FontSize;
  backgroundColor?: Color | ColorV2;
  fontFamily?: FontFamily;
  typography?: keyof typeof TypographyV2;
  padding?: boolean;
  align?: "center" | "left" | "right";
};

export const Text = styled.p<FontProps>`
  color: ${(props) => (props.color ? props.color : Color.MidnightBlue)};
  ${(props) => TypographyV2.h3}
  text-decoration: none;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "none"};
  ${(props) => props.padding && "padding: 5px; border-radius: 4px;"}
  ${(props) => props.align && `text-align: ${props.align};`}
`;
